import { LinkItem } from '@occc/ui-design-system';

import { routeCreator as scanDataRouteCreator } from '../../scan-data.router';

export const buildSubmissionGroupDetailsBreadcrumbs = (label: string): LinkItem[] => [
  {
    label: 'Tobacco Offers',
    to: scanDataRouteCreator.base(),
  },
  { label: 'Details', to: scanDataRouteCreator.submissionGroups() },
  { label },
];
